/** Smooth scroll helpers that cooperate with Lenis when present. */

const HEADER_OFFSET = -88;

export function scrollToId(idOrHash, { behavior = "smooth" } = {}) {
  if (!idOrHash) return;
  const hash = idOrHash.startsWith("#") ? idOrHash : `#${idOrHash}`;
  const el = document.querySelector(hash);
  if (!el) return;

  const lenis = typeof window !== "undefined" ? window.__lenis : null;
  if (lenis && typeof lenis.scrollTo === "function") {
    lenis.scrollTo(el, { offset: HEADER_OFFSET, duration: behavior === "smooth" ? 1.1 : 0 });
    return;
  }

  el.scrollIntoView({ behavior, block: "start" });
}

export function scrollToHashFromLocation() {
  const { hash } = window.location;
  if (!hash) return;
  // Wait one frame so the landing DOM is mounted after client navigation.
  requestAnimationFrame(() => {
    setTimeout(() => scrollToId(hash), 50);
  });
}
